import { FormatFormProps } from '../components/FormatForm/FormatForm';
import { ContentfulFormAssemblyForm } from '@jbhi-fi/apis/src/contentful/types';

export const contentfulApiFormAssemblyFormToFormatForm = ({ fields }: ContentfulFormAssemblyForm): FormatFormProps => {
  return {
    formString: fields?.formAssemblyHtml ?? '',
  };
};
